import React from 'react';
import { useNavigate } from 'react-router-dom';

const FinalCTA = () => {
  const navigate = useNavigate();
  
  return (
    <section className="final-cta dark-section">
      <div className="container">
        {/* Vertical Dividers */}
        <div className="final-cta-divider final-cta-divider-1"></div>
        <div className="final-cta-divider final-cta-divider-2"></div>
        <div className="final-cta-divider final-cta-divider-3"></div>
        <div className="final-cta-divider final-cta-divider-4"></div>
        <div className="final-cta-divider final-cta-divider-5"></div>
        
        <div className="cta-content">
          <div className="cta-content-inner">
            <h2>Ready to Explore Your Own Captive?</h2>
            <p>
              Schedule a discovery call with our team and learn how your portfolio could benefit from a renters insurance captive.
            </p>
          </div>
          <div className="cta-button-wrapper">
            <button 
              className="btn-schedule-cta"
              onClick={() => navigate('/schedule-call')}
            >
              <span>Schedule a Call</span>
              <span className="arrow-icon">↗</span>
            </button>
          </div>
        </div>
        
        <div className="brand-large-container">
          <img 
            src={process.env.PUBLIC_URL + '/images/captiveworks-footers.svg'} 
            alt="captiveworks" 
            className="brand-large-svg"
            onError={(e) => {
              console.error('Image failed to load:', process.env.PUBLIC_URL + '/images/captiveworks-footers.svg');
            }}
            onLoad={() => {
              console.log('Image loaded successfully');
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
